// Frontend/geniac/src/Components/Common/CurrencySelector.tsx
// Composant dropdown pour sélectionner la devise

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrency, Currency } from '../../contexts/CurrencyContext';
import './CurrencySelector.css';

const CURRENCIES: Array<{
  code: Currency;
  symbol: string;
  name: string;
  flag: string;
}> = [
  { code: 'EUR', symbol: '€', name: 'Euro', flag: '🇪🇺' },
  { code: 'USD', symbol: '$', name: 'US Dollar', flag: '🇺🇸' },
  { code: 'GBP', symbol: '£', name: 'British Pound', flag: '🇬🇧' },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc', flag: '🇨🇭' }
];

interface CurrencySelectorProps {
  variant?: 'default' | 'compact';
  className?: string;
}

const CurrencySelector: React.FC<CurrencySelectorProps> = ({
  variant = 'default',
  className = ''
}) => {
  const { t } = useTranslation('common');
  const { currency, setCurrency } = useCurrency();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setCurrency(event.target.value as Currency);
  };

  const selectedCurrency = CURRENCIES.find(c => c.code === currency);

  return (
    <div className={`currency-selector ${variant} ${className}`}>
      <label htmlFor="currency-select" className="currency-label">
        {variant === 'default' && (
          <span className="label-text">{t('labels.currency')}</span>
        )}
      </label>

      <div className="currency-select-wrapper">
        <select
          id="currency-select"
          value={currency}
          onChange={handleChange}
          className="currency-select"
          aria-label={t('labels.selectCurrency')}
        >
          {CURRENCIES.map((curr) => (
            <option key={curr.code} value={curr.code}>
              {variant === 'compact'
                ? `${curr.flag} ${curr.symbol}`
                : `${curr.flag} ${curr.name} (${curr.symbol})`
              }
            </option>
          ))}
        </select>

        {variant === 'default' && selectedCurrency && (
          <span className="selected-currency-info">
            {selectedCurrency.flag} {selectedCurrency.symbol}
          </span>
        )}
      </div>
    </div>
  );
};

export default CurrencySelector;
